"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VoiceRecord = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var VoiceRecord = function VoiceRecord(_a) {
  var id = _a.id;
  var clipPathId = id ? "VoiceRecord__clip0__".concat(id) : 'VoiceRecord__clip0';
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("g", {
    clipPath: "url(#".concat(clipPathId, ")")
  }, react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.993 2.566a.513.513 0 00.164.382l.774.776a.512.512 0 00.382.163c.16 0 .372-.151.67-.364.698-.5 1.87-1.34 3.945-1.34 2.087 0 3.272.85 3.968 1.35.29.207.496.354.646.354a.512.512 0 00.382-.163l.775-.776a.514.514 0 00.163-.382c0-.775-3-2.566-5.934-2.566-3.12 0-5.935 1.89-5.935 2.566zm7.135 4.346a2.18 2.18 0 00-2.4 0 .545.545 0 01-.687-.076l-.786-.776a.535.535 0 01-.153-.425.568.568 0 01.208-.404 4.36 4.36 0 015.236 0c.122.1.197.246.207.404a.535.535 0 01-.152.425l-.786.776a.545.545 0 01-.687.076zM8.655 16.38a3.274 3.274 0 003.273 3.276A3.274 3.274 0 0015.2 16.38v-4.368a3.274 3.274 0 00-3.273-3.276 3.274 3.274 0 00-3.273 3.276v4.367zm9.676 2.937c.138.069.24.191.284.338a.525.525 0 01-.033.47 7.635 7.635 0 01-13.287 0 .525.525 0 010-.426.557.557 0 01.284-.338l1.003-.459a.545.545 0 01.699.218 5.454 5.454 0 009.403 0 .545.545 0 01.698-.218l.95.415z"
  })), react_1.default.createElement("defs", null, react_1.default.createElement("clipPath", {
    id: clipPathId
  }, react_1.default.createElement("path", {
    fill: "currentColor",
    d: "M0 0H24V24H0z"
  }))));
};

exports.VoiceRecord = VoiceRecord;